import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function PaymentCancel() {
  return (
    <main className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <Seo title="Payment Cancelled | HiredToday" description="Payment was cancelled." path="/payment/cancel" />
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-zinc-950">No charge made.</h1>
      <p className="mt-4 text-zinc-600 leading-relaxed">
        You cancelled before paying, so nothing was taken. Your job is saved as a draft in your dashboard. You can finish the payment there whenever you're ready.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/dashboard" data-testid="cancel-go-dashboard"
          className="bg-zinc-950 text-white text-sm font-semibold px-8 py-3.5 rounded-md hover:bg-zinc-800 transition-colors duration-200">
          Back to my dashboard
        </Link>
        <Link to="/pricing" data-testid="cancel-view-pricing"
          className="border border-zinc-300 text-sm font-semibold px-8 py-3.5 rounded-md hover:border-zinc-500 transition-colors duration-200">
          Review pricing
        </Link>
      </div>
    </main>
  );
}
